import Icon from '@/components/ui/AppIcon';

interface ComparisonItem {
  feature: string;
  hayatInteriors: string;
  typicalIndustry: string;
  advantage: boolean;
}

interface ProcessComparisonProps {
  comparisons: ComparisonItem[];
}

const ProcessComparison = ({ comparisons }: ProcessComparisonProps) => {
  return (
    <div className="bg-card rounded-lg shadow-soft overflow-hidden">
      <div className="overflow-x-auto">
        <table className="w-full">
          <thead>
            <tr className="bg-muted/30">
              <th className="font-body font-semibold text-left text-foreground px-6 py-4 w-1/3">
                Process Aspect
              </th>
              <th className="font-body font-semibold text-left text-foreground px-6 py-4 w-1/3">
                <div className="flex items-center space-x-2">
                  <span className="w-3 h-3 bg-primary rounded-full"></span>
                  <span>Hayat Interiors</span>
                </div>
              </th>
              <th className="font-body font-semibold text-left text-foreground px-6 py-4 w-1/3">
                <div className="flex items-center space-x-2">
                  <span className="w-3 h-3 bg-muted-foreground rounded-full"></span>
                  <span>Typical Industry</span>
                </div>
              </th>
            </tr>
          </thead>
          <tbody>
            {comparisons.map((item, index) => (
              <tr
                key={index}
                className={`border-t border-border ${
                  index % 2 === 0 ? 'bg-background' : 'bg-card'
                }`}
              >
                <td className="font-body font-medium text-foreground px-6 py-4">
                  {item.feature}
                </td>
                <td className="px-6 py-4">
                  <div className="flex items-start space-x-2">
                    {item.advantage && (
                      <Icon
                        name="CheckCircleIcon"
                        size={20}
                        variant="solid"
                        className="text-success flex-shrink-0 mt-0.5"
                      />
                    )}
                    <span className="font-body text-sm text-foreground">
                      {item.hayatInteriors}
                    </span>
                  </div>
                </td>
                <td className="px-6 py-4">
                  <span className="font-body text-sm text-muted-foreground">
                    {item.typicalIndustry}
                  </span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ProcessComparison;